import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../lib/contextLib";
import Paper from '@mui/material/Paper';
import BudgetItemForm from '../../../components/BudgetItemForm';

type ItemType = 'income' | 'expense' | 'savings';

interface ConfigEntry {
  label: string;
  returnPath: string;
}

const CONFIG: Record<ItemType, ConfigEntry> = {
  income:  { label: 'income',  returnPath: '/budget/income' },
  expense: { label: 'expense', returnPath: '/budget/expenses' },
  savings: { label: 'saving',  returnPath: '/budget/savings' },
};

interface NewBudgetItemProps {
  itemType: ItemType;
}

export default function NewBudgetItem({ itemType }: NewBudgetItemProps) {
  const navigate = useNavigate();
  const { isAuthenticated } = useAppContext();
  const config = CONFIG[itemType] || CONFIG.income;

  function handleSuccess() {
    navigate(config.returnPath, { replace: true });
  }

  if (!isAuthenticated) {
    return (
      <div className="lander">
        <h1>Making Budgets</h1>
        <p className="text-muted">A simple tool for making budgets</p>
      </div>
    );
  }

  return (
    <div className="new-budget-item">
      <div className="budgetItems stack-md">
        <div className="section-heading">Create new {config.label}</div>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <div className="stack-md">
            <BudgetItemForm mode="create" fixedType={itemType} onSuccess={handleSuccess} />
          </div>
        </Paper>
      </div>
    </div>
  );
}
